import { Component, OnDestroy, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Subject, takeUntil } from 'rxjs';
import { AppModeStatus, OfflineModeService } from '../../services/offline-mode.service';
import { OfflineModalComponent } from '../offline-modal/offline-modal.component';

@Component({
  selector: 'app-offline-mode',
  templateUrl: './offline-mode.component.html',
  styleUrls: ['./offline-mode.component.scss'],
})
export class OfflineModeComponent implements OnInit, OnDestroy {
  isOfflineMode: boolean;

  private readonly destroy$: Subject<void> = new Subject();

  constructor(
    private appModeService: OfflineModeService,
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {
    this.appModeService.appModeStatus$
      .pipe(takeUntil(this.destroy$))
      .subscribe((mode: AppModeStatus) => this.isOfflineMode = mode === AppModeStatus.OFFLINE);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  async openOfflineModal() {
    const modal = await this.modalCtrl.create({
      component: OfflineModalComponent,
      breakpoints: [0, 1],
      initialBreakpoint: 1,
    });
    modal.present();
  }
}
